import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/Reports/InventoryReceivingDetailReport/Filter'

export default createListViewComponent({
  entityName: entityNames.inventoryReceivingDetailReport,
  filterTemplateType: 'InventoryReceivingDetailReport',
  initialFilterDto: (self) => ({
    dateRange: { dateRangeType: 'YearToDate' },
    dateRangeField: 'OrderDateOnly',
  }),
  allowCreate: (self) => false,
  allowSelection: (self) => false,
})(Filter)
